import { ProfileEditForm } from '../../../components';
import { useProfileUpdateForm } from './hooks';

import type { FC } from 'react';
import type { AuthProfileUpdateFormWidgetProps } from './AuthProfileUpdateForm.types';

const AuthProfileUpdateFormWidget: FC<AuthProfileUpdateFormWidgetProps> = ({
  widget,
}) => {
  const {
    user,
    onSubmit,
    countries,
    isSubmitting,
    hasLoadError,
    isUserLoading,
    isCountriesLoading,
    onApplyReferrerCode,
    defaultReferrerCode,
    isApplyingReferrerCode,
    hasApplyReferrerCodeError,
    isApplyingReferrerCodeSuccess,
  } = useProfileUpdateForm(widget);
  const wData = widget.data!;
  return user &&
    !isCountriesLoading &&
    !hasLoadError &&
    !isUserLoading &&
    !isApplyingReferrerCode ? (
    <ProfileEditForm
      user={user}
      data={wData}
      onSubmit={onSubmit}
      countries={countries!}
      config={widget.config}
      isSubmitting={isSubmitting}
      defaultCountry={wData.defaultCountry}
      onApplyReferrerCode={onApplyReferrerCode}
      defaultReferrerCode={defaultReferrerCode}
      hasApplyReferrerCodeError={hasApplyReferrerCodeError}
      isApplyingReferrerCodeSuccess={isApplyingReferrerCodeSuccess}
    />
  ) : null;
};

AuthProfileUpdateFormWidget.displayName = 'AuthProfileUpdateFormWidget';

export { AuthProfileUpdateFormWidget };
